// Compute the header signature for a set of CSV column names.
// Used for mapping auto-apply: two uploads with the same sorted column names
// get the same signature and will match an existing mapping template.
//
// Signature: sha256 of sort(column_names).join('|')
// Order-insensitive, case-sensitive.

/**
 * Compute the header signature for an array of column names.
 * Returns a string in the form `sha256:<hex>`.
 * Uses the Web Crypto API (available in browsers and modern Node/Deno).
 */
export async function computeHeaderSignature(columns: string[]): Promise<string> {
  const sorted = [...columns].sort();
  const payload = sorted.join("|");
  const encoded = new TextEncoder().encode(payload);
  const hashBuffer = await crypto.subtle.digest("SHA-256", encoded);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  return `sha256:${hex}`;
}
